export function getBetDescriptionBetSelector(bet, genericReplace) {
    const desc = bet.descNoHandicap || bet.desc;
    if (bet.parametrica && genericReplace) {
        return desc.replace('@@H1@@', 'x')
                   .replace('@@H2@@', 'x')
                   .replace('@@H3@@', 'x')
                   .replace('@@H4@@', 'x')
                   .replace('@@H5@@', 'x')
                   .replace('@@H6@@', 'x')
                   .replace('@@H7@@', 'x')
                   .replace('@@H8@@', 'x');
    }else {
        return desc;
    }
}
